import { ReactElement } from 'react'
import { ConfigProvider } from 'antd'
import faIR from 'antd/locale/fa_IR'
import JalaliProvider from 'antd-jalali-v5'

export default function AntProvider({ children }: { children: ReactElement }) {
  return (
    <ConfigProvider
      direction='rtl'
      locale={faIR}
      theme={{
        token: {
          fontFamily: 'IRANSans',
          colorPrimary: '#27378B',
          borderRadius: 3
        },
        components: {
          Table: {
            headerBg: '#25368C33'
          }
        }
      }}
    >
      <JalaliProvider />
      {children}
    </ConfigProvider>
  )
}
